import {
    SUB_CATEGORIES_FETCH,
	SUB_CATEGORIES_FETCH_SUCCESS,
    SUB_CATEGORIES_FETCH_RESET,
} from "./types";

export const subCategoriesFetch = payload => {
    return {
        type: SUB_CATEGORIES_FETCH,
        payload: payload
    };
};

export const subCategoriesFetchSuccess = payload => {
    return {
        type: SUB_CATEGORIES_FETCH_SUCCESS,
        payload: payload
    };
};

export const subCategoriesFetchReset = () => {
    return {
        type: SUB_CATEGORIES_FETCH_RESET
    };
};